import { FieldListDto } from "@common/dto/field/list-dto";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";

import { FieldOption } from "@common/dto/field/option";
import { FieldType } from "@common/dto/field/type";
import { FieldPrimaryListDto } from "@common/dto/field/list-primary-dto";

export enum SkipLogicConditionOperator {
  beginsWith = 'BEGINS_WITH',
  contains = 'CONTAINS',
  doesNotBeginWith = 'DOES_NOT_BEGIN_WITH',
  doesNotContain = 'DOES_NOT_CONTAIN',
  doesNotEndWith = 'DOES_NOT_END_WITH',
  doesNotEqual = 'DOES_NOT_EQUAL',
  endsWith = 'ENDS_WITH',
  equals = 'EQUALS',
  in = 'IN',
  isBlank = 'IS_BLANK',
  isGreaterThan = 'IS_GREATER_THAN',
  isGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  isLessThan = 'IS_LESS_THAN',
  isLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO',
  isNotBlank = 'IS_NOT_BLANK',
  isNotIn = 'IS_NOT_IN',
  isNotLike = 'IS_NOT_LIKE',
  like = 'LIKE',
}

export enum SkipLogicConditionParenthesis {
  rightParenthesis = ")",
  leftParenthesis = "(",
}

export enum SkipLogicConditionAndOr {
  and = "AND",
  or = "OR",
}

export type SkipLogicConditionListDto = {
  leftParenthesis: boolean;
  rightParenthesis: boolean;
  operator?: SkipLogicConditionOperator;
  andOR?: SkipLogicConditionAndOr;
  value?: string;
  field: FieldPrimaryListDto;
};

export type SkipLogicConditionCreateDto = {
  field: FieldPrimaryListDto;
  leftParenthesis: boolean;
  rightParenthesis: boolean;
  operator?: SkipLogicConditionOperator;
  andOR?: SkipLogicConditionAndOr;
  value?: string;
};


export type SkipLogicCondition = SkipLogicConditionListDto & {
  id: string;
};

export type SkipLogicField = FieldListDto & {
  options?: Array<FieldOption>;
};

export type SkipLogicProps = {
  className?: string;
  disabled?: boolean;
  onRemove: (conditions: SkipLogicCondition[]) => void;
  onChange: (conditions: SkipLogicCondition[]) => void;
  onAdd?: (params: { condition: SkipLogicConditionCreateDto, conditions: SkipLogicConditionCreateDto[] }) => void;
  conditions: SkipLogicCondition[];
  getFolders?: () => Promise<FolderPrimaryListDto[]>;
  getFields?: (payload: { folderId?: number; system?: boolean; searchQuery?: string }) => Promise<SkipLogicField[]>;
  moduleName: string;
  controls: Array<SkipLogicPredefinedControl>;
  multiple?: boolean;
};

export type SkipLogicFolderField = {
  fieldId: number;
  fieldName: string;
  fieldData?: unknown;
  fieldContext: number;
  fieldTypeId: FieldType;
  fieldTypeName: keyof typeof FieldType;
  systemField: boolean;
  columnWidth: number;
  imageURL: string;
  options?: Array<FieldOption>;
};

export enum SkipLogicPredefinedControlType {
  moveUp = 'moveUp',
  moveDown = 'moveDown',
  add = 'add',
  removeAll = 'removeAll'
};

export type SkipLogicPredefinedControl = {
  type?: SkipLogicPredefinedControlType;
  handler?: (conditions: SkipLogicCondition[]) => void;
  iconSrc?: string;
  description?: string;
  disabled?: boolean
};